// DREAMINK PETAL CONTROL

document.addEventListener('DOMContentLoaded', () => {
  DreamInkPetals.init();
});

const DreamInkPetals = {
  init() {
    const mode = document.body.dataset.petals;

    if (!mode) return;

    if (mode === 'home') {
      this.enablePetals();
    }
  },

  enablePetals() {
    document.body.classList.add('petals-active');
  }
};